import { render } from "./RegistrationSuccess.vue?vue&type=template&id=98c554a8&scoped=true"
import script from "./RegistrationSuccess.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccess.vue?vue&type=script&lang=js"

import "./RegistrationSuccess.vue?vue&type=style&index=0&id=98c554a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c554a8"]])

export default __exports__